import { Dialog as DrawerPrimitive } from "radix-ui";

export const DrawerPortal = DrawerPrimitive.Portal;
